import { extractServerMessage, mapValidationErrors } from "@/app/composables/claim/claimApiErrors";

export function payoutRequestErrorMessage(error: unknown): string {
  const fieldError = Object.values(mapValidationErrors(error))[0];
  if (fieldError) return fieldError;
  const serverMessage = extractServerMessage(error);
  if (serverMessage && serverMessage !== "Validation failed.") return serverMessage;
  return serverMessage || "Something went wrong. Please try again.";
}
